var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetModuleRecordQuery } from "@/store/api";
import Preview from "@/components/widgets/list/preview";
import { useState } from "react";
import DisplayField from "@/components/fields/displayField";
import { FACELIFTDEF } from "@/components/fields/facelift/const";
import { FieldViewType } from "@/components/fields/viewType";
export default function RelateFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata;
    var moduleName = fieldMetadata.module;
    var recordId = record[fieldMetadata.id_name];
    var response = useGetModuleRecordQuery({
        moduleName: moduleName,
        recordId: recordId,
    }).data;
    var relatedRecord = (response === null || response === void 0 ? void 0 : response.data.record) || {};
    var _b = useState(false), clicked = _b[0], setClicked = _b[1];
    var handleClick = function (value) {
        setClicked(value);
    };
    var link = "".concat(process.env.PUBLIC_URL, "/modules/").concat(moduleName, "/DetailView/").concat(recordId);
    return (_jsx("div", __assign({ className: "flex flex-row justify-between relative" }, { children: relatedRecord.id && (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "items-center mx-2 my-1" }, { children: _jsx(DisplayField, { fieldName: "facelift", viewType: FieldViewType.LIST, fieldMetadata: FACELIFTDEF, record: relatedRecord, moduleName: fieldMetadata.module, hideLabel: true }) })), _jsx("span", __assign({ className: "flex items-center text-blue-700 w-[2px] hover:text-blue-400 flex-1 overflow-hidden" }, { children: _jsx("a", __assign({ href: link, className: "truncate" }, { children: record && record[fieldName] })) })), _jsx("div", __assign({ className: "pr-2" }, { children: _jsx(Preview, { record: relatedRecord, module: moduleName || "", handleClick: handleClick }) }))] })) })));
}
